import { render } from "./SideBar.vue?vue&type=template&id=6495b0c2&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import "./SideBar.vue?vue&type=style&index=0&id=6495b0c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6495b0c2"]])

export default __exports__